<template>
  <div class="goods-setting-selector">
    <span class="goods-title">添加商品</span>
    <draggable
      v-if="Array.isArray($$FormData.tabsList[tabIndex].goods_list)"
      v-bind="{sort: true}"
      :list="$$FormData.tabsList[tabIndex].goods_list"
      prevent-on-filter
      animation="200"
      filter=".ignore-drag"
      class="goods-list"
    >
      <transition-group>
        <div v-for="item in $$FormData.tabsList[tabIndex].goods_list" :key="item.sku_id" class="item-goods">
          <img :src="item.thumbnail" :alt="item.goods_name" class="goods-img" />
          <i class="ri-close-circle-fill del-icon" @click="handleDeleteGoods(item)"></i>
        </div>
        <div class="item-goods add ignore-drag" key="add-goods" @click="handleAddGoods">
          <i class="ri-add-line"></i>
        </div>
      </transition-group>
    </draggable>
    <en-source-type-picker
      :show.sync="source_type_picker_show"
      @confirm="handleSourceTypePickerConfirm"
      @close="source_type_picker_show = false"
    />
    <en-goods-sku-picker
      :sku="true"
      :api="goodsListApi"
      :multipleApi="multipleGoodsApi"
      :type="$$DecorType"
      :show.sync="goods_picker_show"
      :source-type="source_type"
      :default-data="defaultGoodsIds"
      terminalType="decor"
      @confirm="handleGoodsPickerConfirm"
      @close="goods_picker_show = false"
    />
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import { decorType } from '@/utils/decor-types'
export default {
  name: 'TabsGoodsSelector',
  components: { Draggable },
  props: {
    tabIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      source_type: '',
      source_type_picker_show: false,
      goods_picker_show: false,
      // 默认商品ID
      defaultGoodsIds: [],
      // 获取商品列表API
      goodsListApi: `${decorType}/goods/skus`,
      // 根据商品id，获取商品列表API
      multipleGoodsApi: `${decorType}/goods/skus/@ids/details`
    }
  },
  methods: {
    /**
     * 添加商品
     */
    handleAddGoods() {
      this.source_type_picker_show = true
    },
    /**
     * 删除商品
     * @param item
     */
    handleDeleteGoods(item) {
      const index = this.$$FormData.tabsList[this.tabIndex].goods_list.findIndex(_item => _item.sku_id === item.sku_id)
      this.$$FormData.tabsList[this.tabIndex].goods_list.splice(index, 1)
    },
    /**
     * 商品选择器确定
     * @param items
     */
    handleGoodsPickerConfirm(items) {
      items = JSON.parse(JSON.stringify(items))
      let goodsList = this.$$FormData.tabsList[this.tabIndex].goods_list.filter(item => item.sku_type !== this.source_type)
      this.$$FormData.tabsList[this.tabIndex].goods_list = [...goodsList, ...items]
    },
    /**
     * 商品来源选择器确定
     * @param source_type
     */
    handleSourceTypePickerConfirm(source_type) {
      this.source_type = source_type
      if (this.source_type !== 'NORMAL') {
        this.goodsListApi = `${decorType}/goods/supplier/skus`
        this.multipleGoodsApi = `${decorType}/goods/supplier/skus/@ids/details`
        let defaultGoods = this.$$FormData.tabsList[this.tabIndex].goods_list.filter(item => item.sku_type === source_type)
        this.defaultGoodsIds = defaultGoods.map(item => item.sku_id)
      } else {
        this.goodsListApi = `${decorType}/goods/skus`
        this.multipleGoodsApi = `${decorType}/goods/skus/@ids/details`
        let defaultGoods = this.$$FormData.tabsList[this.tabIndex].goods_list.filter(item => !item.sku_type)
        this.defaultGoodsIds = defaultGoods.map(item => item.sku_id)
      }
      this.goods_picker_show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-setting-selector {
  width: 100%;
  padding-bottom: 12px;
  box-sizing: border-box;
  background-color: #ffffff;
  .goods-title {
    width: 100%;
    height: 30px;
    font-size: 14px;
    color: #969799;
    line-height: 18px;
    white-space: nowrap;
  }
  .goods-list {
    padding: 12px 16px;
    background-color: #f7f8fa;
    box-sizing: border-box;
    &>span {
      display: flex;
      flex-wrap: wrap;
    }
    .item-goods {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 50px;
      padding: 0;
      margin: 5px 10px 5px 0;
      border: none;
      box-shadow: 0 0 4px 0 rgba(10,42,97,0.2);
      color: #155bd4;
      font-size: 14px;
      background-color: #ffffff;
      border-radius: 2px;
      cursor: move;
      &.add {
        cursor: pointer;
      }
      &:hover {
        .del-icon {
          display: block;
        }
        &:not(.add)::after {
          display: block;
        }
      }
      &::after {
        display: none;
        content: "";
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 1px solid #155bd4;
        border-radius: 2px;
        z-index: 1;
        pointer-events: none;
      }
      .goods-img {
        display: block;
        width: 100%;
        height: 100%;
        margin: 0;
        overflow: hidden;
      }
      .del-icon {
        display: none;
        position: absolute;
        z-index: 2;
        top: -10px;
        right: -10px;
        border-radius: 50%;
        color: #bbbbbb;
        font-size: 20px;
        background-color: #ffffff;
        line-height: normal;
        cursor: pointer;
      }
    }
  }
}
</style>